module.exports = __webpack_public_path__ + "img/numbers_correct.59ebf932.png";